import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session'; // Import sessionStorage
import userSlice from '../slice/userSlice';
import leadSlice from '../slice/leadSlice';
import contactSlice from '../slice/contactSlice';
import emailTemplateSlice from '../slice/emailTemplateSlice';
import policySlice from '../slice/policySlice';
import taskSlice from '../slice/taskSlice';
import smsSlice from '../slice/smsSlice';
import meetingSlice from '../slice/meetingSlice';
import callSlice from '../slice/callSlice';
import emailSlice from '../slice/emailSlice';
import documentSlice from '../slice/documentSlice';
import calendarSlice from '../slice/calendarSlice';
import paymentSlice from '../slice/paymentSlice';
import smsTemplateSlice from '../slice/smsTemplateSlice';
import dashboardSlice from '../slice/dashboardSlice';
import accountingSlice from '../slice/accountingSlice';
import agencySlice from '../slice/agencySlice';
import WAcampaignSlice from '../slice/WAcampaignSlice';
import WAcontactSlice from '../slice/WAcontactSlice';
import WAgroupSlice from '../slice/WAgroupSlice';
import WAconversationSlice from '../slice/WAconversationSlice';
import WAtemplateSlice from '../slice/WAtemplateSlice';
import policyNumberSlice from '../slice/policyNumberSlice';
import underwriterSlice from '../slice/underwriterSlice';
import reminderSlice from '../slice/reminderSlice';
import systemErrorSlice from '../slice/systemErrorSlice';

const middleware = (getDefaultMiddleware) => {
    return getDefaultMiddleware({
        serializableCheck: false,
    });
};

const userPersistConfig = {
    key: 'userDetails',
    storage: storageSession,
};
const leadPersistConfig = {
    key: 'leadDetails',
    storage: storageSession,
};
const contactPersistConfig = {
    key: 'contactDetails',
    storage: storageSession,
};
const emailTemPersistConfig = {
    key: 'tempDetails',
    storage: storageSession,
};
const smsTemPersistConfig = {
    key: 'smsTempDetails',
    storage: storageSession,
};


export const store = configureStore({
    reducer: {
        userDetails: persistReducer(userPersistConfig, userSlice),
        leadDetails: persistReducer(leadPersistConfig, leadSlice),
        contactDetails: persistReducer(contactPersistConfig, contactSlice),
        tempDetails: persistReducer(emailTemPersistConfig, emailTemplateSlice),
        smsTempDetails: persistReducer(smsTemPersistConfig, smsTemplateSlice),
        policyDetails: policySlice,
        taskDetails: taskSlice,
        smsDetails: smsSlice,
        paymentDetails: paymentSlice,
        meetingDetails: meetingSlice,
        callDetails: callSlice,
        emailDetails: emailSlice,
        documentDetails: documentSlice,
        calendarDetails: calendarSlice,
        dashboardDetails: dashboardSlice,
        accountingDetails: accountingSlice,
        agencyDetails: agencySlice,
        WAcampaignDetails: WAcampaignSlice,
        WAcontactDetails: WAcontactSlice,
        WAgroupDetails: WAgroupSlice,
        WAconversationDetails: WAconversationSlice,
        WAtemplateDetails: WAtemplateSlice,
        policyNumberDetails: policyNumberSlice,
        underwriterDetails: underwriterSlice,
        reminderDetails: reminderSlice,
        systemErrorDetails: systemErrorSlice,
    },
    middleware,
});

export const persistor = persistStore(store);
